import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";

const MasterLedger = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const ledgerData = [
    {
      date: "01-Apr-2025",
      particulars: "Opening Balance",
      bill: 0,
      receipt: 0,
      interest: 0,
      balance: 0,
    },

    {
      date: "01-Apr-2025",
      particulars: "Maintenance Bill - April",
      bill: 3000,
      receipt: 0,
      interest: 0,
      balance: 3000,
    },

    {
      date: "01-May-2025",
      particulars: "Interest on April Bill",
      bill: 0,
      receipt: 0,
      interest: 150,
      balance: 3150,
    },

    {
      date: "01-May-2025",
      particulars: "Maintenance Bill - May",
      bill: 3000,
      receipt: 0,
      interest: 0,
      balance: 6150,
    },

    {
      date: "10-Jun-2025",
      particulars: "Receipt Received",
      bill: 0,
      receipt: 5000,
      interest: 0,
      balance: 1150,
    },

    {
      date: "01-Jun-2025",
      particulars: "Maintenance Bill - June",
      bill: 3000,
      receipt: 0,
      interest: 0,
      balance: 4150,
    },

    {
      date: "01-Jul-2025",
      particulars: "Interest on Pending Amount",
      bill: 0,
      receipt: 0,
      interest: 200,
      balance: 4350,
    },

    {
      date: "15-Jul-2025",
      particulars: "Receipt Received",
      bill: 0,
      receipt: 5000,
      interest: 0,
      balance: -650,
    },
  ];

  const finalBalance =
    ledgerData[ledgerData.length - 1]?.balance || 0;

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
              marginTop: "20px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            <h2
              style={{
                color: "#0d47a1",
                marginBottom: "20px",
              }}
            >
              Master Ledger
            </h2>

            {/* Member Info */}
            <div
              style={{
                display: "flex",
                gap: "40px",
                marginBottom: "20px",
                padding: "15px",
                background: "#f5f7fa",
                borderRadius: "8px",
              }}
            >
              <div>
                <strong>Member Name:</strong> John Doe
              </div>

              <div>
                <strong>Flat No:</strong> A-101
              </div>

              <div>
                <strong>Wing:</strong> A
              </div>
            </div>

            {/* Ledger Table */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "#0d47a1",
                    color: "#fff",
                  }}
                >
                  <th style={thStyle}>Date</th>
                  <th style={thStyle}>Particulars</th>
                  <th style={thStyle}>Bill</th>
                  <th style={thStyle}>Interest</th>
                  <th style={thStyle}>Receipt</th>
                  <th style={thStyle}>Balance</th>
                  <th style={thStyle}>Status</th>
                </tr>
              </thead>

              <tbody>
                {ledgerData.map((row, index) => (
                  <tr key={index}>
                    <td style={tdStyle}>{row.date}</td>

                    <td style={tdStyle}>
                      {row.particulars}
                    </td>

                    <td style={tdStyle}>
                      ₹ {row.bill.toLocaleString()}
                    </td>

                    <td style={tdStyle}>
                      ₹ {row.interest.toLocaleString()}
                    </td>

                    <td style={tdStyle}>
                      ₹ {row.receipt.toLocaleString()}
                    </td>

                    <td style={tdStyle}>
                      ₹{" "}
                      {Math.abs(
                        row.balance
                      ).toLocaleString()}
                    </td>

                    <td style={tdStyle}>
                      {row.balance > 0 ? (
                        <span
                          style={{
                            color: "#d32f2f",
                            fontWeight: "bold",
                          }}
                        >
                          Pending
                        </span>
                      ) : row.balance < 0 ? (
                        <span
                          style={{
                            color: "#2e7d32",
                            fontWeight: "bold",
                          }}
                        >
                          Advance
                        </span>
                      ) : (
                        <span
                          style={{
                            color: "#1565c0",
                            fontWeight: "bold",
                          }}
                        >
                          Cleared
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Summary Cards */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginTop: "25px",
              }}
            >
              <div style={cardStyle}>
                <h4>Total Outstanding</h4>

                <h2
                  style={{
                    color:
                      finalBalance > 0
                        ? "#d32f2f"
                        : "#2e7d32",
                  }}
                >
                  ₹ {Math.abs(finalBalance)}
                </h2>
              </div>

              <div style={cardStyle}>
                <h4>Status</h4>

                <h2
                  style={{
                    color:
                      finalBalance > 0
                        ? "#d32f2f"
                        : "#2e7d32",
                  }}
                >
                  {finalBalance > 0
                    ? "Pending"
                    : finalBalance < 0
                    ? "Advance Payment"
                    : "Cleared"}
                </h2>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const thStyle = {
  border: "1px solid #ddd",
  padding: "12px",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
};

const cardStyle = {
  flex: 1,
  padding: "20px",
  borderRadius: "10px",
  background: "#f5f7fa",
  textAlign: "center",
};

export default MasterLedger;